import classNames from '@form-engine/core-util/class-names';
import React, { CSSProperties, useEffect, useRef, useState } from 'react';

export interface BuilderScaledContainerProps
    extends React.ComponentProps<'div'> {
    width?: number;
    targetProps?: React.ComponentProps<'div'>;
}

export default function BuilderScaledContainer({
    width = 768,
    children,
    targetProps = {},
    className,
    ...props
}: BuilderScaledContainerProps) {
    const container = useRef<HTMLDivElement>(null);
    const target = useRef<HTMLDivElement>(null);
    const [scale, setScale] = useState(1);
    const [height, setHeight] = useState(1);

    useEffect(() => {
        if (!container.current || !target.current) return;

        const containerElement = container.current;

        let mounted = true;

        const update = () => {
            if (!container.current || !target.current || !mounted) return;

            const { height: th } = target.current.getBoundingClientRect();
            const { width: cw } = containerElement.getBoundingClientRect();
            const newScale = cw / width;
            if (scale !== newScale) setScale(newScale);
            if (height !== th) setHeight(th);
        };

        const observer = new ResizeObserver(update);
        observer.observe(containerElement);
        update();
        return () => {
            mounted = false;
            observer.unobserve(containerElement);
        };
    }, [width, setScale, setHeight, height, scale]);

    return (
        <div
            {...props}
            className={classNames('feb-element-preview', className)}
            ref={container}
            style={
                {
                    '--height': `${height}px`,
                    '--scale': scale,
                    '--width': `${width}px`,
                } as CSSProperties
            }
        >
            <div
                {...targetProps}
                className={classNames(
                    'feb-element-preview__target',
                    targetProps?.className
                )}
                ref={target}
            >
                {children}
            </div>
        </div>
    );
}
